/* eslint-disable react/prop-types */
import ErrorOutlineIcon from "@mui/icons-material/ErrorOutline";
import Button from "@mui/material/Button";
import { green, red } from "@mui/material/colors";
import useTrackedCubeQuery from "../../../Utils/UtilFunctions/useTrackedCubeQuery";
import { hasInvalidCubePayload } from "../../../Utils/UtilFunctions/cubeUtil";
import { alpha } from "@mui/material";
import { useContext } from "react";
import { AppContext } from "../../../App";
import LoadingButton from "@material-ui/lab/LoadingButton";

interface ButtonCubeResponseProps {
  tag: string;
  limit: number;
  statusParam: any;
}

const ButtonCubeResponse: React.FC<ButtonCubeResponseProps> = ({
  tag,
  limit,
  statusParam,
}) => {
  const appContextProps: any = useContext(AppContext);
  const query: any = {
    dimensions: [`${appContextProps?.selectedPlantForCube}LastValueAgg.tagName`,`${appContextProps?.selectedPlantForCube}LastValueAgg.description`,`${appContextProps?.selectedPlantForCube}LastValueAgg.deviceName`],
    measures: [`${appContextProps?.selectedPlantForCube}LastValueAgg.lastValue`],
    filters: [
      {
        member: `${appContextProps?.selectedPlantForCube}LastValueAgg.tagName`,
        operator: "equals",
        values: [tag],
      },
    ],
    // timeDimensions: [
    //   {
    //     dimension: `${appContextProps?.selectedPlantForCube}LastValueAgg.timestamp`,
    //     granularity: "minute",
    //     dateRange: "today",
    //   },
    // ],
    // order: [
    //   [`${appContextProps?.selectedPlantForCube}LastValueAgg.timestamp`, "desc"],
    // ],
    // limit: limit,
  };
  const { resultSet, isLoading, error, progress } = useTrackedCubeQuery(query, {
    skip: hasInvalidCubePayload(query),
  });

  if (progress) return <b>Progessing..</b>;
  if (isLoading)
    return (
      <LoadingButton loading loadingPosition="end" variant="outlined">
        Status
      </LoadingButton>
    );
  if (error) return <ErrorOutlineIcon fontSize="small" color="error" />;
  if (resultSet) {
    const fetchedData = resultSet
      ?.serialize()
      .loadResponse.results.map((ele: any) => {
        return ele.data;
      });
    const singleData: any = fetchedData
      ?.map((dataArray: any) => {
        return dataArray.map((datapoint: any) => {
          const key: any = Object.keys(datapoint).find((key: any) => {
            return key.includes("lastValue");
          });
          return datapoint[key];
        });
      })
      .flat();
    return (
      <Button
        variant="contained"
        disabled
        style={{
          color: singleData[0] === statusParam.R ? green[300] : red[300],
          backgroundColor:
            singleData[0] === statusParam.R
              ? alpha(green[700], 0.3)
              : alpha(red[700], 0.3),
        }}
        color={singleData[0] === statusParam.R ? "success" : "error"}
      >
        {singleData[0] === statusParam.R ? "Running" : "Not Running"}
      </Button>
    );
  }

  return null;
};

export default ButtonCubeResponse;
